import * as types from './mutations-types';

export const mutations = {
  [types.FETCH_DBSTATS_STARTED](state) {
    state.isDbStatsLoading = true;
  },
  [types.FETCH_DBSTATS_SUCCESS](state, { numDocuments, docs }) {
    state.isDbStatsLoading = false;
    state.numDocuments = numDocuments;
    if (docs) {
      state.notificationDocs = docs;
    }
  },
  [types.FETCH_DBSTATS_FAILURE](state) {
    state.isDbStatsLoading = false;
  },
  [types.FETCH_RSSFEEDS_STARTED](state) {
    state.isRssFeedsLoading = true;
  },
  [types.FETCH_RSSFEEDS_SUCCESS](state, { numRssUpdates, feeds }) {
    state.isRssFeedsLoading = false;
    state.numRssUpdates = numRssUpdates;
    state.feeds = feeds;
  },
  [types.FETCH_RSSFEEDS_FAILURE](state) {
    state.isRssFeedsLoading = false;
  },
  [types.FETCH_PREFS_STARTED](state) {
    state.notificationPrefs = { ...state.notificatoinPrefs, isLoading: true };
  },
  [types.FETCH_PREFS_SUCCESS](state, { enabled, frequency }) {
    state.notificationPrefs = { isLoading: false, enabled, frequency };
  },
  [types.FETCH_PREFS_FAILURE](state) {
    state.notificationPrefs = { ...state.notificatoinPrefs, isLoading: false };
  },
  [types.UPDATE_PREFS_STARTED](state) {
    state.notificationPrefs = { ...state.notificationPrefs, isLoading: true };
  },
  [types.UPDATE_PREFS_SUCCESS](state, { enabled, frequency }) {
    state.notificationPrefs = { isLoading: false, enabled, frequency };
  },
  [types.UPDATE_PREFS_FAILURE](state) {
    state.notificationPrefs = { ...state.notificationPrefs, isLoading: false };
  },
  resetNotifications(state) {
    state.isDbStatsLoading = false;
    state.numDocuments = 0;
    state.notifiacationDocs = [];

    state.isRssFeedsLoading = false;
    state.numRssUpdates = 0;
    state.feeds = [];
  },
};
